import React from 'react';

/**
 * Homly Logo — Brand component
 * Violet profond → Orange chaud en dégradé continu sur le "ly"
 */
export function HomlyLogo({ size = 'md', variant = 'default' }) {
    const sizes = {
        xs: 'text-base',
        sm: 'text-lg',
        md: 'text-xl',
        lg: 'text-2xl',
        xl: 'text-3xl',
        '2xl': 'text-4xl',
    };

    return (
        <span
            className={`font-heading font-extrabold tracking-tight ${sizes[size]} bg-clip-text text-transparent`}
            style={{
                backgroundImage: 'linear-gradient(135deg, #7C3AED, #F59E0B)',
                letterSpacing: '-0.02em',
            }}
        >
            Homly
        </span>
    );
}

export default HomlyLogo;
